import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AdminUsuario {
  id: number;
  tipo: 'CANDIDATO' | 'EMPRESA';
  nombre: string;
  correo: string;
  authProvider: string;
  activo: boolean;
  verificado: boolean;
  createdAt: string;
  subscriptionStatus?: string;
  subscriptionPlan?: string;
  subscriptionPeriodEnd?: string;
  duplicado?: boolean;
  guruMatchUsos?: number;
  cvOptimizerUsos?: number;
  freebieUsado?: boolean;
  guruMatchUsageDates?: string[];
}

export interface AdminUsuariosPage {
  content: AdminUsuario[];
  total: number;
  page: number;
  size: number;
}

export interface AdminUsuariosFiltros {
  tipo: string;
  buscar: string;
  authProvider: string;
  activo: string;
  sortBy: string;
  sortDir: string;
}

@Injectable({ providedIn: 'root' })
export class AdminUsuariosService {

  private base = `${environment.baseApi}/privado/admin/usuarios`;

  constructor(private http: HttpClient) {}

  listar(filtros: AdminUsuariosFiltros, page: number, size: number): Observable<AdminUsuariosPage> {
    let params = new HttpParams()
      .set('tipo', filtros.tipo)
      .set('buscar', filtros.buscar)
      .set('authProvider', filtros.authProvider)
      .set('activo', filtros.activo)
      .set('sortBy', filtros.sortBy)
      .set('sortDir', filtros.sortDir)
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<AdminUsuariosPage>(this.base, { params });
  }

  toggleActivo(tipo: 'CANDIDATO' | 'EMPRESA', id: number, activo: boolean): Observable<any> {
    const seg = tipo === 'CANDIDATO' ? 'candidato' : 'empresa';
    return this.http.put(`${this.base}/${seg}/${id}/activo`, { activo });
  }

  eliminar(tipo: 'CANDIDATO' | 'EMPRESA', id: number, force = false): Observable<any> {
    const seg = tipo === 'CANDIDATO' ? 'candidato' : 'empresa';
    const params = force ? '?force=true' : '';
    return this.http.delete(`${this.base}/${seg}/${id}${params}`);
  }

  resetUsos(id: number): Observable<any> {
    return this.http.delete(`${this.base}/candidato/${id}/usos`);
  }

  exportarExcel(): Observable<Blob> {
    return this.http.get(`${this.base}/exportar`, { responseType: 'blob' });
  }

  enviarCorreo(candidatoIds: number[], subject: string, content: string): Observable<{
    enviados: number;
    fallidos: number;
    errores: string[];
  }> {
    return this.http.post<{ enviados: number; fallidos: number; errores: string[] }>(
      `${this.base}/enviar-correo`,
      { candidatoIds, subject, content }
    );
  }
}
